import React, { useState, useEffect } from 'react';
import Button from './Button';
import api from '../services/api';
import toast from 'react-hot-toast';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const RconManager = ({ shop }) => {
  const [command, setCommand] = useState('');
  const [response, setResponse] = useState('');
  const [rconSettings, setRconSettings] = useState({
    host: '',
    port: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (shop && shop.rcon) {
      setRconSettings({
        host: shop.rcon.host || '',
        port: shop.rcon.port || '',
        password: '', // Password is not sent from backend for security
      });
    }
  }, [shop]);

  const handleSettingsChange = (e) => {
    setRconSettings({ ...rconSettings, [e.target.name]: e.target.value });
  };

  const handleSaveSettings = async () => {
    try {
      await api.put(`/shops/${shop._id}/rcon`, rconSettings);
      toast.success('Ustawienia RCON zostały zapisane.');
    } catch (err) {
      console.error(err);
      toast.error('Nie udało się zapisać ustawień RCON.');
    }
  };

  const generatePassword = () => {
    const length = 16;
    const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
    let retVal = "";
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    setRconSettings({ ...rconSettings, password: retVal });
  };

  const handleSendCommand = async () => {
    try {
      const res = await api.post(`/shops/${shop._id}/rcon`, { command });
      setResponse(res.data.response);
    } catch (err) {
      console.error(err);
      setResponse(err.response?.data?.message || 'Error sending command');
    }
  };

  return (
    <div className="mt-8 p-6 glass rounded-xl">
      <h2 className="text-2xl font-bold mb-6 text-white">Zarządzanie RCON</h2>
      
      {/* RCON configuration form */}
      <div className="space-y-4 mb-8">
        <h3 className="text-xl font-bold text-white">Konfiguracja</h3>
        <div>
          <label htmlFor="host" className="block text-sm font-medium text-gray-300">Host/IP</label>
          <input type="text" name="host" id="host" value={rconSettings.host} onChange={handleSettingsChange} className="input mt-1" placeholder="127.0.0.1" />
        </div>
        <div>
          <label htmlFor="port" className="block text-sm font-medium text-gray-300">Port</label>
          <input type="number" name="port" id="port" value={rconSettings.port} onChange={handleSettingsChange} className="input mt-1" placeholder="25575" />
        </div>
        <div>
          <label htmlFor="password" className="block text-sm font-medium text-gray-300">Hasło</label>
          <div className="relative flex items-center mt-1">
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              id="password"
              value={rconSettings.password}
              onChange={handleSettingsChange}
              className="input flex-grow pr-10"
              placeholder="Nowe hasło (pozostaw puste, aby nie zmieniać)"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-400 hover:text-white"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
          <Button onClick={generatePassword} className="btn-secondary w-full mt-2">Generuj Nowe Hasło</Button>
        </div>
        <Button onClick={handleSaveSettings} className="btn-primary w-full">Zapisz Ustawienia</Button>
      </div>

      {/* Send command */}
      <div>
        <h3 className="text-xl font-bold mb-2 text-white">Wyślij komendę</h3>
        <div className="flex">
          <input
            type="text"
            className="input rounded-r-none flex-grow"
            value={command}
            onChange={(e) => setCommand(e.target.value)}
            placeholder="np. say Witaj na serwerze!"
          />
          <Button onClick={handleSendCommand} className="btn-primary rounded-l-none">
            Wyślij
          </Button>
        </div>
        {response && (
          <div className="mt-4 p-4 bg-black/30 rounded-lg">
            <pre className="text-gray-200 whitespace-pre-wrap">{response}</pre>
          </div>
        )}
      </div>
    </div>
  );
};

export default RconManager;